<template>
  <div
    v-if="loding"
    class="w-full grid md:grid-cols-5 grid-cols-2 md:gap-4 gap-2 box-border p-[10px]"
  >
    <div
      v-for="(item, index) in list"
      :key="index"
      class="w-full flex items-center justify-center flex-col cursor-pointer"
      @click="handelVideo(item)"
    >
      <div
        class="w-full max-h-[140px] h-full flex items-center justify-center stui-vodlist__thumb posr"
      >
        <img
          class="w-full max-h-[140px] h-full rounded-[5px]"
          v-lazy="{ src: item.vod_pic ? item.vod_pic : item.logo, error: lod_image }"
          alt=""
        />
        <!-- <van-image
          class="w-full max-h-[140px] h-full rounded-[5px]"
          :src="item.image"
          lazy-load
          @error="handleError"
        >
        </van-image> -->
        <span class="play"></span>
      </div>
      <div class="o-h-e-s text-[14px] text-[#fff] min-h-[38px] md:hover:text-[#ae6600]">
        {{ item.vod_name ? item.vod_name : item.title }}
      </div>
      <div class="text-[12px] text-[#999] w-full flex items-center justify-between">
        <span>{{ item.vod_time }}</span>
        <!-- <span>64011次播放</span> -->
        <span v-if="item.views"></span>
        <span v-else class="h-[16px]"></span>
      </div>
    </div>
  </div>
  <div v-else class="w-full min-h-[500px] flex items-center justify-center text-[#fff]">
    <van-loading vertical>
      <template #icon>
        <van-icon name="star-o" size="30" />
      </template>
      加载中...
    </van-loading>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import CryptoJS from 'crypto-js'
import { useRouter } from 'vue-router'

const router = useRouter()
// 密钥（必须保密，可以存环境变量）
const SECRET_KEY = 'your-secret-key'
function encryptData(data) {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString()
  return ciphertext
}
const props = defineProps({
  list: {
    type: Array,
    default: () => []
  },
  isType: {
    type: Boolean,
    default: false
  },
  loding: {
    type: Boolean,
    default: false
  },
  lod_image: {
    type: String,
    default: ''
  }
})
const emits = defineEmits(['onVideo'])
const handelVideo = (item) => {
  // console.log(item, 'item')
  if (!item.type_id) {
    window.open(item.href, '_blank')
    return
  }

  localStorage.setItem('video', JSON.stringify(encryptData(item)))

  if (!props.isType) {
    router.push({
      path: '/video',
      query: {
        id: item.type_id
      }
    })
  } else {
    emits('onVideo', item)
  }
}
const handleError = (event) => {
  event.target.src = props.lod_image
  event.target.style = 'border: 1px solid #fff'
}
</script>

<style scoped>
.stui-vodlist__thumb:hover .play {
  display: block;
}

.play {
  display: none;
  position: absolute;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1) url('@/assets/images/play.png') center no-repeat;
}
.bor {
  border: 1px solid #fff;
}
/* 只影响 loading 状态的占位图 */
.lazy-img[lazy='loading'] {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
</style>
